import { render } from "./componentsTable.vue?vue&type=template&id=6089e6d9"
import script from "./componentsTable.vue?vue&type=script&lang=js"
export * from "./componentsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__